//
// Shop: Global events on add\remove product to cart
//

( function($, waTheme) {

    var Cart = (function($) {

        var change_functions = [];

        Cart = function(options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$items = that.$wrapper.find(".b-cart__items");
            // that.$badge = that.$wrapper.find(".b-cart__badge");
            // that.$count = that.$wrapper.find(".b-cart__count");
            that.$total = that.$wrapper.find(".b-cart__total");

            // VARS
            console.warn("cart init");

            // DYNAMIC VARS
            that.count = options["count"];

            // INIT
            that.initClass();
        };

        Cart.prototype.initClass = function() {
            var that = this;

            $(document).on("cartIsChanged", function(event, data) {
                that.update(data);
            });

            $(document).on("click", ".js-remove-from-cart", function() {
                var product_id = $(this).parents(".b-cart__item").data("product-id");
                that.onRemove($(this).parents(".b-cart__item"), product_id);
            });
        };

        /**
         * @param {Object} data
         * */
        Cart.prototype.update = function(data, update_cart_counter = true) {
            var that = this;

            let count = data.count;
            if (window.waTheme.themesettings.settings["apps__shop_common_counter_type_buttons_type_buttons"]["value"] === "products_quantity") {
                // get quantity of all items
                let quantity = 0;
                for (const itemKey in data["items"]) {
                    quantity += data["items"][itemKey]["quantity"];
                }
                count = quantity > data.count ? quantity : data.count;
            }

            if (count > 0) {
                $(".js-cart-count").text(count);
                $(".js-cart-badge").removeClass("d-none");
                that.count = (count);
                toggle(true);

                if (data.total) {
                    that.$total.html(data.total);
                }

                if (that.$items.length) {
                    var $promise = $.get(`${window.waTheme.cart_url}?update_items=1`, function (html) {
                        $("body").append(html);
                    });

                    $promise.then( function(response) {
                        if (update_cart_counter === true) {
                            that.updateItems(data.items);
                        }
                    });
                }

            } else {
                $(".js-cart-count").text(0);
                $(".js-cart-badge").addClass("d-none");
                that.count = 0;
                toggle();
            }

            function toggle(show) {
                var dropdown_class = "invisible";

                if (show) {
                    that.$wrapper.find(".b-cart__dropdown-menu").removeClass(dropdown_class);
                } else {
                    that.$wrapper.find(".b-cart__dropdown-menu").addClass(dropdown_class);
                }
            }

            $.each(change_functions, function(index, func) {
                try {
                    func(that);
                } catch(e) {
                    console.log(e.message);
                }
            });

            // событие обновления товаров в корзине
            if (update_cart_counter === true) {
                $(document).trigger('update_cart_counter');
            }
        };

        Cart.prototype.updateItems = function(items) {
            var that = this,
                html = "";

            console.log(items);

            // if (items) {
                // get items
                let cart_items = window.waTheme.cart_items;

                for (const item of items) {

                    console.log(item);

                    if (item["image_url"] === null) {
                        var image = `${window.waTheme.theme.url}assets/img/svg/empty_photo.svg`;
                    } else {
                        var image = item["image_url"];
                    }

                    let compare_price = 0;
                    if (cart_items[item["id"]] !== undefined && parseInt(cart_items[item["id"]]["compare_price"]) > parseInt(cart_items[item["id"]]["price"])) {
                        compare_price = waTheme.formatPrice(cart_items[item["id"]]["compare_price"] * item["quantity"], {currency: cart_items[item["id"]]["currency"]});
                    }

                    html += `<div class="b-cart__item" data-product-id="${item["id"]}">
                            <a class="b-cart__item-image" href="${item["frontend_url"]}">
                                <img class="b-lazyload rounded" data-src="${image}" alt="${item["name"]}">
                            </a>
                            <a class="b-cart__item-content link-emphasis" href="${item["frontend_url"]}">
                                <div class="b-cart__item-name">
                                    ${item["name"]}
                                    <span class="text-quaternary"> x ${item["quantity"]}</span>
                                </div>
                                <div class="d-flex gap-2 text-emphasis">
                                    <span class="b-cart__item-price">
                                        ${item["full_price"]}
                                    </span>
                                    ${compare_price !== 0 ?
                        `<span class="b-cart__item-compare_price text-decoration-line-through">${compare_price}</span>`
                        : ''}
                                </div>
                            </a>
                            <button class="btn btn-gray-theme-link p-0 icon icon-sm ms-auto align-self-start js-remove-from-cart" type="button">
                                ${window.waTheme.icons["trash"]}
                            </button>
                         </div>`;
                }
            // }

            that.$items.html(html);

            //
            waTheme.init.site.ImageLazyLoad.update();
        };

        /**
         * @param {Function} func
         * */
        Cart.prototype.onChange = function(func) {
            if (typeof func === "function") {
                change_functions.push(func);
            }
        };

        Cart.prototype.onRemove = function($product, product_id) {
           var that = this,
               data = {
                   html: 1,
                   items: 1,
                   id: product_id
               };

           $.post(window.waTheme.cart_url + "delete/", data, function (response) {
               // console.log(response);
               //
               $product.remove();
               //
               that.update(response["data"], false);
               //
               that.$total.html(response["data"]["total"]);

           }, "json");
        };

        return Cart;

    })($);

    waTheme.init.shop.Cart = Cart;

    var $wrapper = $(".b-cart");
    if ($wrapper.length) {
        waTheme.apps["shop"].cart = new window.waTheme.init.shop.Cart({
            $wrapper: $wrapper
        });
    }

})(jQuery, window.waTheme);
